<template>
  <div class="main-wrapper">
    <section class="section main-section text-center bg-gradient-default">
      <main class="container card shadow shadow-lg--hover mt-3">
        <div class="row mb-3 mt-3">
          <div class="col-12">
            <img src="../assets/aesssa-logo.png" class="aesssa-logo" />
          </div>
          <div class="col-12">
            <h2>Oups! Not Found</h2>
          </div>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
section.main-section {
  height: 100%;
}

.aesssa-logo {
  max-width: 140px;
  max-height: 140px;
}
</style>
